import Drawer from 'common/components-v2/modal/Drawer';
import { useUI } from 'common/context/UIContext';
import { Flex } from '@motili/ui';
import LegacyUnmetRequirementsModal from './UnmetRequirementsModal-Legacy';
import { ExpandableLabel } from '../../../../common/components/ExpandableLabel';

const UnmetRequirementsModal = ({
    handleClose,
    unmetPhotoRequirementsList,
    unmetVideoRequirementsList,
    UnmetRequirementsHeader,
    isOpen,
}: UnmetRequirementsModalProp) => {
    return (
        <Drawer
            drawerStyle={{
                width: '45%',
            }}
            onClose={handleClose}
            title={
                <span style={{ fontSize: '21px', fontWeight: '600' }}>
                    Media Requirements
                </span>
            }
            showClose
            open={isOpen}
        >
            <Flex
                style={{
                    marginBottom: '20px',
                    fontWeight: '600',
                    marginLeft: '-2px',
                }}
            >
                {UnmetRequirementsHeader()}
            </Flex>
            <div
                style={{
                    marginBottom: '20px',
                    marginLeft: '-12px',
                }}
            >
                {unmetPhotoRequirementsList && (
                    <div style={{ marginBottom: '20px' }}>
                        <ExpandableLabel
                            label='PHOTO REQUIREMENTS'
                            defaultExpanded
                        >
                            {unmetPhotoRequirementsList}
                        </ExpandableLabel>
                    </div>
                )}
                {unmetVideoRequirementsList && (
                    <div style={{ marginBottom: '20px' }}>
                        <ExpandableLabel
                            label='VIDEO REQUIREMENTS'
                            defaultExpanded
                        >
                            {unmetVideoRequirementsList}
                        </ExpandableLabel>
                    </div>
                )}
            </div>
        </Drawer>
    );
};

interface UnmetRequirementsModalProp {
    handleClose: () => void;
    unmetPhotoRequirementsList: any;
    unmetVideoRequirementsList: any;
    UnmetRequirementsHeader: () => string;
    isOpen: boolean;
}

const UnmetRequirementsModalWrapper = (props: UnmetRequirementsModalProp) => {
    const { isLegacyUI } = useUI();
    return isLegacyUI ? (
        <LegacyUnmetRequirementsModal {...props} />
    ) : (
        <UnmetRequirementsModal {...props} />
    );
};
export default UnmetRequirementsModalWrapper;
export { UnmetRequirementsModal };
